export const UPSERT_PRODUCER = `
mutation upsertProducer($key: String!) {
  upsertProducer(key: $key){
    __typename
    ... on SyncBoolean{
      status
    }
    ... on ResultError{
      status_code
      message
    }
  }
}
`;
